import React from 'react';
import { GutterType } from '../variables';
import styled from 'styled-components';

type ListLayoutRowProps = {
    children: React.ReactNode;
    justifyContent?: string;
    alignItems?: string;
    flexDirection?: string;
    marginTop?: GutterType;
    marginBottom?: GutterType;
    marginLeft?: GutterType;
    marginRight?: GutterType;
    zIndex?: number;
    position?: 'relative' | 'absolute';
    top?: number | 'inherit';
    bottom?: number | 'inherit';
    left?: number | 'inherit';
    right?: number | 'inherit';
    className?: string;
};

export const ListLayoutRow = styled('div').withConfig({
    shouldForwardProp: (prop) => ['children'].includes(prop),
})<ListLayoutRowProps>`
    &&& {
        display: flex;
        align-items: ${(props: ListLayoutRowProps) => props.alignItems ?? 'center'};
        flex-direction: ${(props: ListLayoutRowProps) => props.flexDirection ?? 'row'};
        justify-content: ${(props: ListLayoutRowProps) => props.justifyContent ?? 'space-between'};
        position: ${(props: ListLayoutRowProps) => props.position ?? 'relative'};
        top: ${(props: ListLayoutRowProps) => props.top ?? 'inherit'}px;
        bottom: ${(props: ListLayoutRowProps) => props.bottom ?? 'inherit'}px;
        left: ${(props: ListLayoutRowProps) => props.left ?? 'inherit'}px;
        right: ${(props: ListLayoutRowProps) => props.right ?? 'inherit'}px;
        margin-top: ${(props: ListLayoutRowProps) => props.marginTop ?? 0}px;
        margin-bottom: ${(props: ListLayoutRowProps) => props.marginBottom ?? 0}px;
        margin-left: ${(props: ListLayoutRowProps) => props.marginLeft ?? 0}px;
        margin-right: ${(props: ListLayoutRowProps) => props.marginRight ?? 0}px;
        z-index: ${(props: ListLayoutRowProps) => props.zIndex ?? 10};
    }
`;
